<template>
    <div ref="thickness" class="thicknessClass">
        <div class="box" ref="box">
            <canvas  ref="mycanvas" class="canvas" ></canvas>
        </div>
        <p>avg thickness：{{ list.avgThickness }}</p>
        <p>total volume：{{ list.totalVolume }}</p>
    </div>
</template>

<script>
export default {
  name: 'thicknessPart',
  props: {
    list: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      cav: '',
      iwidth: 50,
      len: 0,
      inum: 0
    }
  },
  watch: {
    list (newval, oldval) {
      this.init()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init () {
      setTimeout(() => {
        this.crliwidth()
        this.cav = this.$refs.mycanvas
        console.log('window.screen.height', window.screen.height)
        const ww = 250
        const hh = 250
        // if (window.screen.height >= 1200) {
        //   ww = 300
        //   hh = 300
        // }
        const width = ww
        const height = hh
        this.cav.width = ww
        this.cav.height = hh
        let r = 125
        const x1 = (((2 - Math.sqrt(2)) / 2) * r).toFixed(2)// 直綫端點坐標
        const x0 = width / 2
        const y0 = height / 2
        const ctx = this.cav.getContext('2d')
        ctx.strokeStyle = '#252122'
        for (let k = 0; k < this.inum - 1; k++) {
          ctx.beginPath()
          ctx.arc(x0, y0, r, 0, Math.PI * 2, false)
          ctx.stroke()
          r = r - this.iwidth
        }
        ctx.beginPath()
        ctx.moveTo(x1, x1)
        ctx.lineTo(width - x1, height - x1)
        ctx.stroke()
        ctx.beginPath()
        ctx.moveTo(width - x1, x1)
        ctx.lineTo(x1, height - x1)
        ctx.stroke()
        // r = r - this.iwidth
        ctx.beginPath()
        ctx.arc(x0, y0, r, 0, Math.PI * 2, false)
        ctx.fillStyle = '#fff'
        ctx.fill()
        ctx.stroke()
        if (this.list.length !== 0) {
          for (let i = 0; i < this.list.low.length; i++) {
            this.writeTxt(ctx, this.list.low[i], i, 0)
            if (this.list.lowp.length !== 0) {
              this.writeTxt(ctx, this.list.lowp[i], i, 2)
            }
          }
          for (let j = 0; j < this.list.cloumn.length; j++) {
            this.writeTxt(ctx, this.list.cloumn[j], j, 1)
            if (this.list.cloumnp.length !== 0) {
              this.writeTxt(ctx, this.list.cloumnp[j], j, 3)
            }
          }
        }
      }, 1000)
    },
    // 计算圆环之间的宽度
    crliwidth () {
      this.len = 5
      if (this.list.length !== 0 && this.list.low.length !== 0) {
        this.len = this.list ? this.list.low.length : 5
      } else if (this.list.length !== 0 && this.list.cloumn.length !== 0) {
        this.len = this.list ? this.list.cloumn.length : 5
      }

      this.inum = Math.ceil(this.len / 2)

      this.iwidth = 250 / (this.inum * 2 - 1)
      // console.log(this.iwidth)
    },
    writeTxt (ctx, txt, index, l) {
      ctx.font = '14px "微软雅黑"'
      ctx.fillStyle = '#252122'
      ctx.textAlign = 'center'
      const x = this.iwidth / 2
      const iw = index * this.iwidth
      const xp = this.cav.width / 2 + 15
      if (l === 0) { // x轴
        ctx.fillText(txt, x + iw, this.cav.height / 2)
      } else if (l === 1) { // y轴
        ctx.fillText(txt, this.cav.width / 2, x + iw)
      } else if (l === 2) { // x轴波动范围
        ctx.fillText('±' + txt, x + iw, xp)
      } else if (l === 3) { // y轴波动范围
        ctx.fillText('±' + txt, this.cav.width / 2, x + iw + 15)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.thicknessClass{
    width: 100%;
    // height: 100%;
    .box{
        // position: relative;
        width:100%;
        height:100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #000000;
        .canvas {
            margin: 0 auto;
            background-color: #fff;
        }
    }

    p{
        text-align: left;
        font-size: 16px;
        color:#00A1AE;
        font-weight: bold;
    }
}
</style>
